import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { getPowerSellPrices, InstallationPowerPriceDto } from 'src/Libs/flow/installation/api'
import { transposeArrayType } from 'src/Libs/flow/utils'
import { usePortalQuery } from 'src/Libs/api'

type ReturnType = {
  powerSellPrice: InstallationPowerPriceDto | null
  isLoading: boolean
  refetch: () => void
}

export const useFetchCurrentPowerSellPrice = (installationId: number | undefined): ReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, refetch } = usePortalQuery({
    queryKey: ['installation', installationId, 'power-sell-prices'],
    queryFn: () => getPowerSellPrices(installationId!, authFetch),
    select: result => {
      const data = result ? transposeArrayType(result) : []
      // Find last active power sell price (the one with end = null)
      const activePowerSellPrice = data.find(psp => psp.end === null) as InstallationPowerPriceDto
      return activePowerSellPrice ?? null
    },
    enabled: !!installationId,
  })

  return {
    powerSellPrice: data ?? null,
    isLoading,
    refetch,
  }
}
